import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ViewStore, for use in the registry */ export const ViewStoreActionTypes = [
    ActionType.DeleteEntitySucceededAction,
    ActionType.DeltaSyncSucceededAction,
    ActionType.ReportValidCustomFieldDefinitionsAction,
    ActionType.SetCategoryLabelModeAction,
    ActionType.SetLeftNavExpandedAction,
    ActionType.SetPlanFilterAction,
    ActionType.SetSortCriteriaAction,
    ActionType.SetTaskFilterAction,
    ActionType.SetTaskGroupingStateAction,
    ActionType.SetGridColumnWidthAction,
    ActionType.SetGridColumnWidthsAction,
    ActionType.SetFABStateAction,
    ActionType.SetCopilotPaneStateAction,
    ActionType.SetCopilotSidecarStateAction,
    ActionType.SetUiCommandRequestAction,
    ActionType.SetDabDefaultExpandedAction,
    ActionType.FetchRoamingUserDataSucceededAction,
    ActionType.UpdateRoamingUserDataAction,
    ActionType.UpdateRoamingUserDataSucceededAction,
    ActionType.UpdateRoamingUserDataFailedAction,
    ActionType.SetScreenWidthAction,
    ActionType.SetAddGoalRowVisibilityAction,
    ActionType.SetTaskEditorRenderModeAction,
    ActionType.SetTaskEditorSidePanelWidthAction,
    ActionType.SetGanttZoomScaleAction,
    ActionType.SetUnscheduledColumnVisibilityAction,
    ActionType.SetTaskEditorSelectedTabAction,
    ActionType.SetAgentOutputUnseenAction,
    ActionType.SetTaskEditorActiveSidePanelAction,
    ActionType.SetSelectedDynamicFilter
];
